import MasterService from "./MasterService";

export const CommonService = {
    ...MasterService,

    getMasterConfig() {
        return this.post('/common/master/config')
    },

    getPartnerList() {
        return this.post('/common/partner-list')
    },

    addDocument(params: object) {
        return this.post('/common/uploadDoc',params)
    },

}